import { useFeatureToggle } from '@flopflip/react-redux';
import useEditorOverride from 'app/shared/components/forms/FormEditor/hooks/useEditorOverride';
import { PAGELESS_EDITOR_QUERY_PARAM } from 'app/shared/components/forms/FormEditor/hooks/useEditorOverride/constants';

import { FeatureFlag } from 'constants/featureFlags';

const useIsPrismPagelessEditorEnabled = () => {
  const isFlagEnabled = useFeatureToggle(FeatureFlag.EnablePrismPagelessEditor);
  const override = useEditorOverride(PAGELESS_EDITOR_QUERY_PARAM);

  return override ?? isFlagEnabled;
};

export default useIsPrismPagelessEditorEnabled;
